import script from "./UDropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./UDropdownMenu.vue?vue&type=script&setup=true&lang=ts"

import "./UDropdownMenu.vue?vue&type=style&index=0&id=a13e616e&lang=scss"

const __exports__ = script;

export default __exports__